module.exports = __webpack_public_path__ + "img/total-score.201f1307.png";